import React, { useContext, useMemo } from "react";

import { funnelDecorator } from "./thirdPartyTrackingAgent";
import { ThirdPartyTrackingAgentContext } from "./TrackingProvider";

interface TrackingFunnelProviderProps {
  funnel: string;
  children: React.ReactNode;
}
export const TrackingFunnelProvider = ({
  funnel,
  children,
}: TrackingFunnelProviderProps) => {
  const thirdPartyTrackingAgent = useContext(ThirdPartyTrackingAgentContext);
  const funnelThirdPartyTrackingAgent = useMemo(
    () => funnelDecorator(funnel, thirdPartyTrackingAgent),
    [funnel, thirdPartyTrackingAgent],
  );
  return (
    <ThirdPartyTrackingAgentContext.Provider
      value={funnelThirdPartyTrackingAgent}
    >
      {children}
    </ThirdPartyTrackingAgentContext.Provider>
  );
};
